import {isNonEmptyArray, isNonNullObject} from "../classes/Utils";
import {Bom, BomDetail, BomEntry, IBomParent} from "./bom.interface";
import {PossibleActions} from "./admin.interface";

export enum Sex { M ='M', F = 'F'}

export enum Action {
    NEW_OBJECT = "new",
    EDIT_OBJECT = "edit",
    VIEW_OBJECT = "view",
    DEL_OBJECT = "del",
    TOGGLE_OBJECT = "toggle",
}

export interface InObj {
    id: number
    name: string
}

export interface Address {
    address?: string;
    zipCode?: string;
    city?: string;
    province?: string;
    district?: string;
}

export interface UpdateMetadata {
    creationUser: string
    creationDatetime: Date
    updateUser: string
    updateDatetime: Date
}

export interface Result {
    company: string
    updateMetadata: UpdateMetadata
    possibleActions?: PossibleActions

}

export interface RequestConfig {
    excludes?: string[]
    deleteExcludes?: string[]
}

export abstract class BaseDto<Dto, Req> {

    forUi() {
        return this;
    }

    public asRequest(config?: RequestConfig): Req {
        const req = this.toRequest(Object.assign(<Dto>{}, this), config);
        return req;
    }

    toRequest(obj: Dto, config?: RequestConfig): Req {
        const excludes = isNonNullObject(config)
                && isNonEmptyArray(config.excludes) ? config.excludes : []
        for (const key of Object.keys(obj)) {
            if(excludes.indexOf(key) >= 0)
                continue
            if(obj[key] instanceof Object && obj[key].id)
                obj[key] = obj[key].id
        }
        delete obj["id"]
        delete obj["possibleActions"]
        delete obj["creationMetadata"]
        delete obj["companyName"]
        if(this.isDeleted("headquarter", config))
            delete obj['headquarter']
        return obj as unknown as Req
    }

    isDeleted(field: string, config?: RequestConfig) {
        if(config && config.deleteExcludes != null) {
            return !(config.deleteExcludes.indexOf(field) >= 0)
        }
        return true;
    }
}

export function updateBomRequest(req: IBomParent, bom: Bom, postDesc: boolean = true) {
    req['totalCost'] = bom.totalCost
    req['taxableTotal'] = bom.taxableTotal
    req['total'] = bom.total
    req['customerTaxableTotal'] = bom.customerTaxableTotal
    req['buyerTaxableTotal'] = bom.buyerTaxableTotal

    const entries = bom.entries == null ? [] :
        bom.entries.map(e => {
            const details = e.entries.map(d => {
                const res = getBomDetail(d)
                return res
            })

            const res = getBomEntry(e, details)
            if(!postDesc) {
                delete res['description']
                delete res['longDescription']
            }

            return res;
        })
    req['entries'] = entries
}

export function getBomEntry(e: BomEntry, details: any[]) {
    const res = {
        id: e.id < 0 ? null : e.id,
        configured: e.configured,
        product: e.product.id,
        description: e.description,
        longDescription: e.longDescription,
        supplier: e.supplier.id,
        um: e.um.id,
        quantity: e.quantity,
        listPrice: e.listPrice,
        sellDiscount: e.sellDiscount,
        discount: e.discount,
        discountCode: e._discountEntrySelection.name,
        markupPrct: e.markupPrct,
        cost: e.cost,
        totalCost: e.totalCost,
        price: e.price,
        totalPrice: e.totalPrice,
        specificationsItem: null,
        entries: details
    }

    if(e.specificationsItem) {
        res.specificationsItem = {
            item: e.specificationsItem.item.id,
            description: e.specificationsItem.item.description,
            customerPrice: e.specificationsItem.customerPrice,
            buyerPrice: e.specificationsItem.buyerPrice,
            totalCustomerPrice: e.specificationsItem.totalCustomerPrice,
            totalBuyerPrice: e.specificationsItem.totalBuyerPrice,
            extraBudget: e.specificationsItem.extraBudget
        }
    }
    return res;
}

export function getBomDetail(d: BomDetail) {
    const res = {
        id: d.id < 0 ? null : d.id,
        product: d.product.id,
        supplier: d.supplier.id,
        description: d.description,
        longDescription: d.longDescription,
        um: d.um.id,
        quantity: d.quantity,
        coefficient: d.coefficient,
        listPrice: d.listPrice,
        discountCode: d._discountEntrySelection.name,
        discount: d.discount,
        cost: d.cost,
        totalCost: d.totalCost
    }
    return res;
}

export class Outcome {
    success: boolean = true
    code: string | null
    message: string | null
    description: string | null
    violations: Array<Violation>[] = []
    provided: boolean = true

    static toError(outcome: Outcome) {
        if(outcome.violations && Object.keys(outcome.violations).length > 0) {
            let msg = `${outcome.message}`
            return msg;
        }
        else {
            // outcome.code = "AAAA";
            // outcome.message = "Pota l'è capitàt";
            // outcome.description = ''
            const descMsgEq = outcome.description && outcome.message && outcome.description === outcome.message
            const showMsg = outcome.message && !descMsgEq
            const msg = `${outcome.code ? '(' + outcome.code + ') - ' : ''}
                ${showMsg ? (outcome.message) : ''}
                ${outcome.description ? ((showMsg ? ': ' : ' ') + outcome.description) : ''}`;
            return msg;
        }
    }
}

export class Violation {

}

export class Response<T> {

    outcome: Outcome
    data?: T
    total?: number

    constructor(data: T, outcome: Outcome = new Outcome()) {
        this.outcome = outcome;
        this.data = data;
    }
}
